<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-configuration">
    <el-tabs v-model="activeTab" tab-position="left" @tab-click="handleTabClick" :before-leave="beforeLeave">
      <el-tab-pane v-if="isRoleAllow([4001, 4101, 4111, 4121, 4141, 900001, 900002])" name="targetSubTitle" :disabled="true" label="Targets:" class="sub-title">
        <!-- <wy-analytics-configuration-target-subtitle ref="configurationTargetSubtitle" :controller="controller"/> -->
      </el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4001, 900001])" name="targetExperienceAutomation" label="Experience & Automation">
        <wy-analytics-configuration-target-experience-automation ref="configurationTargetExperienceAutomation" :controller="controller"/>
      </el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4001, 900001])" name="targetContactReasons" label="Conversation Topics">
        <wy-analytics-configuration-target-contact-reasons ref="configurationTargetContactReasons" :controller="controller"/>
      </el-tab-pane> 
      <el-tab-pane v-if="isRoleAllow([4101, 4111, 4121, 4141, 900002])" name="targetVaOptimization" label="Virtual Agent Analytics">
        <wy-analytics-configuration-target-va-optimization ref="configurationTargetVaOptimization" :controller="controller"/>
      </el-tab-pane>

      <el-tab-pane v-if="isRoleAllow([4201, 900011, 900013, 900002])" name="databaseSubTitle" :disabled="true" label="Database:" class="sub-title">
      </el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4201, 900011])" name="topics" label="Conversation Topics">
        <wy-analytics-configuration-topics ref="configurationTopics" :controller="controller"/>
      </el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4201, 900013])" name="topicBlacklist" label="Conversation Topics Blacklist">
        <wy-analytics-configuration-topic-blacklist ref="configurationTopicBlacklist" :controller="controller"/>
      </el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4201, 900013])" name="messageBlacklist" label="Messages Blacklist">
        <wy-analytics-configuration-message-blacklist ref="configurationMessageBlacklist" :controller="controller"/>
      </el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4201, 900002])" name="intentsToHandoff" label="Intents to handoff">
        <wy-analytics-configuration-intents-to-handoff ref="configurationIntentsToHandoff" :controller="controller"/>
      </el-tab-pane>

      <el-tab-pane v-if="isRoleAllow([4201, 900008])" name="transcriptsSubTitle" :disabled="true" label="Transcripts:" class="sub-title"></el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4201, 900008])" name="summaryGeneration" label="Summary Generation Prompt">
        <wy-analytics-configuration-summary-generation-prompt ref="configurationSummaryGenerationPrompt" :controller="controller"/>
      </el-tab-pane>

      <el-tab-pane v-if="isRoleAllow([4201, 900006])" name="alertsSubTitle" :disabled="true" label="Alerts:" class="sub-title"></el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4201, 900006])" name="overallKPIs" label="Overall Bot Metrics">
        <wy-analytics-configuration-alert-overall-kpis ref="configurationAlertOverallKPIs" :controller="controller"/>
      </el-tab-pane>
      <el-tab-pane v-if="isRoleAllow([4201, 900006]) && isRoleAllow([4200])" name="topicKPIs" label="Topic Metrics">
        <wy-analytics-configuration-alert-topic-kpis ref="configurationAlertTopicKPIs" :controller="controller"/>
      </el-tab-pane>

      <el-tab-pane v-if="isC1Auth && isRoleAllow([900003, 900004])" name="configurationsTitle" :disabled="true" label="Configurations:" class="sub-title"></el-tab-pane>
      <el-tab-pane v-if="isC1Auth && isRoleAllow([900003, 900004])" name="companyConfigurations" label="Company Configuration">
        <wy-configurations-company-configuration ref="companyConfiguration"/>
      </el-tab-pane>
      <el-tab-pane v-if="isC1Auth && isSpecialUser" name="globalConfigurations" label="Global Configuration">
        <wy-configurations-global-configuration ref="globalConfiguration"/>
      </el-tab-pane>

      <el-tab-pane v-if="!hideTemp" name="keywordBlacklist" label="Keyword Blacklist">
        Keyword Blacklist coming soon...
      </el-tab-pane>
      <el-tab-pane v-if="!hideTemp" name="entities" label="Entities">
        Entities coming soon...
      </el-tab-pane>
      <el-tab-pane v-if="!hideTemp" name="anomalySensititivies" label="Anomaly Sensititivies">
        Anomaly Sensititivies coming soon...
      </el-tab-pane>
    </el-tabs>

    <wy-dialogue ref="wyDialogue" defaultTitle="Hmmm, below action is still in progress">
      <div class="dialogue-content-container">
        <div><div class="dialogue-content-header"><b>Action:</b></div> {{processStatusInfo.action}}</div>
        <div><div class="dialogue-content-header"><b>Process ID :</b></div> {{processStatusInfo.processId}}</div>
        <div><div class="dialogue-content-header"><b>Action by :</b></div> {{processStatusInfo.actionBy}}</div>
        <div><div class="dialogue-content-header"><b>Start date :</b></div> {{processStatusInfo.startDate}}</div>
      </div>
      <!--div v-if="true" class="red-warning">
          There’s another topic with the same name.
      </div-->
    </wy-dialogue>
    <wy-dialog 
      ref="updateDialog"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Save"
      discardButtonLabel="Discard"
    />

  </div>
</template>

<script>
import WyAnalyticsConfigurationTopics from './wy-analytics-configuration-topics';
import WyAnalyticsConfigurationTopicBlacklist from './wy-analytics-configuration-topic-blacklist';
import WyAnalyticsConfigurationMessageBlacklist from './wy-analytics-configuration-message-blacklist';
import WyAnalyticsConfigurationIntentsToHandoff from './wy-analytics-configuration-intents-to-handoff';

import WyAnalyticsConfigurationTargetExperienceAutomation from './wy-analytics-configuration-target-experience-automation';
import WyAnalyticsConfigurationTargetContactReasons from './wy-analytics-configuration-target-contact-reasons';
import WyAnalyticsConfigurationTargetVaOptimization from './wy-analytics-configuration-target-va-optimization';

import WyAnalyticsConfigurationAlertOverallKPIs from './wy-analytics-configuration-alert-overall-kpis';
import WyAnalyticsConfigurationAlertTopicKPIs from './wy-analytics-configuration-alert-topic-kpis';

import wyAnalyticsConfigurationSummaryGenerationPrompt from './wy-analytics-configuration-summary-generation-prompt.vue';

import WyConfigurationsCompanyConfiguration from '../../configurations/wy-configurations-company-configuration';
import WyConfigurationsGlobalConfiguration from '../../configurations/wy-configurations-global-configuration';

import WyDialog from '../../widgets/wy-dialog.vue'
import WyDialogue from '../../widgets/wy-dialogue.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'wy-analytics-configuration',
  modalTitle: 'Configuration',
  modelContentStyle: 'width: calc(100vw - 100px) !important; max-width: unset !important; max-width: unset !important; height: calc(100vh - 100px);',

  components: { 
    'wy-analytics-configuration-topics': WyAnalyticsConfigurationTopics,
    'wy-analytics-configuration-topic-blacklist': WyAnalyticsConfigurationTopicBlacklist,
    'wy-analytics-configuration-message-blacklist': WyAnalyticsConfigurationMessageBlacklist,
    'wy-analytics-configuration-intents-to-handoff': WyAnalyticsConfigurationIntentsToHandoff,
    
    'wy-analytics-configuration-target-experience-automation': WyAnalyticsConfigurationTargetExperienceAutomation,
    'wy-analytics-configuration-target-contact-reasons': WyAnalyticsConfigurationTargetContactReasons,
    'wy-analytics-configuration-target-va-optimization': WyAnalyticsConfigurationTargetVaOptimization,

    'wy-analytics-configuration-alert-overall-kpis': WyAnalyticsConfigurationAlertOverallKPIs,
    'wy-analytics-configuration-alert-topic-kpis': WyAnalyticsConfigurationAlertTopicKPIs,

    'wy-analytics-configuration-summary-generation-prompt': wyAnalyticsConfigurationSummaryGenerationPrompt,

    'wy-dialogue': WyDialogue,
    'wy-dialog': WyDialog,

    'wy-configurations-company-configuration': WyConfigurationsCompanyConfiguration,
    'wy-configurations-global-configuration': WyConfigurationsGlobalConfiguration,
  },

  props: ['appVue'],
  
  data() {
    return {
      controller: this,
      activeTab: '',
      hideTemp: true,
      isModified: false,
      isDashBoardModified: false,
      processStatusInfo: {},
      hasNoSavedChanges: false,
      hasError: false,

      overallKpis: ['bes', 'bas', 'vaVolume', 'vaContainedVolume', 'totalMessages', 'containedConversationsTrueResolvedVolume', 'negativeFeedbackScore', 'understandingPercent'],
      topicKpis: ['volume', 'avgBes', 'avgAes', 'avgBas', 'containment'],
      hiddenOverallKpisMetricsMapping: {
        'containedTrueResolved': 'containedConversationsTrueResolvedVolume'
      },
      hiddenTopicKpisMetricsMapping: {}
    };
  },

  computed: {
    ...mapGetters(['isC1Auth', 'dataModel', 'companyConfig', 'currentPageInfo', 'isRoleAllow', 'authUser', 'companyProfileSettings', 'isSpecialUser']),
  },

  methods: {
    ...mapActions(['fetchCompanyProfileSettings']),
    beforeLeave(newTab, oldTab) {
      if(this.controller.hasNoSavedChanges) {
        this.handleUnSavedChanges(newTab, oldTab, null)
        return false
      }
    },

    handleTabClick(tab) {
      if(!this.hasNoSavedChanges) {
        if(this.$refs.configurationTopics && tab.name == 'topics' && !this.$refs.configurationTopics.loading) {
          this.$refs.configurationTopics.loadTopics();
        }
        if(this.$refs.configurationTopicBlacklist && tab.name == 'topicBlacklist' && !this.$refs.configurationTopicBlacklist.loading) {
          this.$refs.configurationTopicBlacklist.loadBlackList();
        }
        if(this.$refs.configurationTargetExperienceAutomation && tab.name == 'targetExperienceAutomation') {
          this.$refs.configurationTargetExperienceAutomation.loading = true;
          this.$refs.configurationTargetExperienceAutomation.prepareData();
          if(this.$refs.configurationTargetExperienceAutomation.$refs.targetDefaultTable) this.$refs.configurationTargetExperienceAutomation.$refs.targetDefaultTable.refreshTable();
        }
        if(this.$refs.configurationTargetContactReasons && tab.name == 'targetContactReasons') {
          this.$refs.configurationTargetContactReasons.isEditing = false;
          this.$refs.configurationTargetContactReasons.loading = true;
          this.$refs.configurationTargetContactReasons.prepareData();
          
        }
        if(this.$refs.configurationTargetVaOptimization && tab.name == 'targetVaOptimization') {
          this.$refs.configurationTargetVaOptimization.loading = true;
          this.$refs.configurationTargetVaOptimization.prepareData();
          setTimeout(() => {
            if(this.$refs.configurationTargetVaOptimization.$refs.targetOverviewTable) {
              this.$refs.configurationTargetVaOptimization.activeName = 'overview';
              this.$refs.configurationTargetVaOptimization.tableColumns = this.$refs.configurationTargetVaOptimization.overviewTableColumns;
              this.$refs.configurationTargetVaOptimization.$refs.targetOverviewTable.refreshTable();
            }
            else if(this.$refs.configurationTargetVaOptimization.$refs.targetComparisonTable) {
              this.$refs.configurationTargetVaOptimization.activeName = 'performanceComparison';
              this.$refs.configurationTargetVaOptimization.tableColumns = this.$refs.configurationTargetVaOptimization.comparisonTableColumns;
              this.$refs.configurationTargetVaOptimization.$refs.targetComparisonTable.refreshTable();
            }
            else if(this.$refs.configurationTargetVaOptimization.$refs.targetResponsePerformanceTable) {
              this.$refs.configurationTargetVaOptimization.activeName = 'responsePerformance';
              this.$refs.configurationTargetVaOptimization.tableColumns = this.$refs.configurationTargetVaOptimization.responsePerformanceTableColumns;
              this.$refs.configurationTargetVaOptimization.$refs.targetResponsePerformanceTable.refreshTable();
            }
            else if(this.$refs.configurationTargetVaOptimization.$refs.targetNluIntentPerformanceTable) {
              this.$refs.configurationTargetVaOptimization.activeName = 'nluIntentPerformance';
              this.$refs.configurationTargetVaOptimization.tableColumns = this.$refs.configurationTargetVaOptimization.nluIntentPerformanceTableColumns;
              this.$refs.configurationTargetVaOptimization.$refs.targetNluIntentPerformanceTable.refreshTable();
            }
            
          }, 200);
        }
        if(tab.name == 'overallKPIs') {
          // this.$refs.configurationAlertTopicKPIs.loading = true;
          // this.$refs.configurationAlertTopicKPIs.prepareData();
          // this.$refs.configurationAlertOverallKPIs.checkRuleDuplicate();
        }
        
        if(tab.name == 'topicKPIs') {
          // this.$refs.configurationAlertTopicKPIs.loading = true;
          // this.$refs.configurationAlertTopicKPIs.prepareData();
          // this.$refs.configurationAlertTopicKPIs.activeNames = []
          // this.$refs.configurationAlertTopicKPIs.checkRuleDuplicate();
        }
        this.resetTopicAlertTabs();
      }
    },

    resetTopicAlertTabs() {
      if(this.$refs.configurationAlertTopicKPIs) {
        this.$refs.configurationAlertTopicKPIs.activeNames = [];
      }
      if(this.$refs.configurationAlertOverallKPIs) {
        this.$refs.configurationAlertOverallKPIs.activeNames = [];
      }
      if(this.$refs.configurationAlertTopicKPIs) {
        this.$refs.configurationAlertTopicKPIs.activeTopicNames = [];
      }
    },

    showDialogue(processStatusInfo) {
      this.processStatusInfo = processStatusInfo;
      this.$refs.wyDialogue.show = true;
    },

    async beforeModalClose() {
      // fire this event before the modal close
      if(this.isModified && this.$router.currPageComponent && this.$router.currPageComponent.$options.name == 'wy-analytics-contact-reasons' && this.$router.currPageComponent.refreshPage) {
        this.$router.currPageComponent.refreshPage();
      }

      // fire this when bes & bas Dashboard setting is updated.
      if (
        this.isDashBoardModified &&
        this.$router.currPageComponent &&
        (this.$router.currPageComponent.$options.name == 'wy-experience-and-automation-page' ||
          this.$router.currPageComponent.$options.name == 'wy-home-experience-automation-panel-performance-gauge-summary')
      ) {
        this.$router.currPageComponent.handleFilterChange(true);
      }
    },

    afterModalClose() {
      // fire this event after the modal close
    },

    handleUnSavedChanges(newTab, oldTab, handleAppModalClose) {
      let hasSubTab = false;
      if(this.hasNoSavedChanges) {
        if(oldTab == 'targetExperienceAutomation') {
          this.$refs.configurationTargetExperienceAutomation.handleSaveUnchanges(newTab, handleAppModalClose)
        }
        if(oldTab == 'targetContactReasons') {
          this.$refs.configurationTargetContactReasons.handleSaveUnchanges(newTab, handleAppModalClose)
        }
        if(oldTab == 'targetVaOptimization') {
          hasSubTab = true;
          this.$refs.configurationTargetVaOptimization.handleSaveUnchanges(newTab, handleAppModalClose, hasSubTab)
        }
        if(oldTab == 'summaryGeneration') {
          hasSubTab = true;
          this.$refs.configurationSummaryGenerationPrompt.handleSaveUnchanges(newTab, handleAppModalClose, hasSubTab)
        }
        if(oldTab == 'overallKPIs') {
          this.$refs.configurationAlertOverallKPIs.handleSaveUnchanges(newTab, handleAppModalClose)
        }
        if(oldTab == 'topicKPIs') {
          this.$refs.configurationAlertTopicKPIs.handleSaveUnchanges(newTab, handleAppModalClose)
        }
        return false
      }
    },

    filterOutHiddenMetrics(vaoOverViewPageMetrics) {
      if(Object.keys(this.hiddenOverallKpisMetricsMapping).length > 0) {
        Object.keys(this.hiddenOverallKpisMetricsMapping).forEach(key => {
          if(!vaoOverViewPageMetrics[key]) {
            let index = this.overallKpis.indexOf(this.hiddenOverallKpisMetricsMapping[key])
            if(index > -1) {
              this.overallKpis.splice(index, 1)
            }
          }
        })
      }
      if(Object.keys(this.hiddenTopicKpisMetricsMapping).length > 0) {
        Object.keys(this.hiddenTopicKpisMetricsMapping).forEach(key => {
          if(!vaoOverViewPageMetrics[key]) {
            let index = this.topicKpis.indexOf(this.hiddenTopicKpisMetricsMapping[key])
            if(index > -1) {
              this.topicKpis.splice(index, 1)
            }
          }
        })
      }
    }
  },

  async created() {
    await this.fetchCompanyProfileSettings();
    if(this.isRoleAllow([4001, 900001])) {
      this.activeTab = "targetExperienceAutomation";
    }
    else if(this.isRoleAllow([4101, 4111, 4121, 4141, 900002])) {
      this.activeTab = "targetVaOptimization";
    }
    else if(this.isRoleAllow([4201, 900011, 900013])) {
      this.activeTab = "topics"
    }

    if(this.$attrs.options && this.$attrs.options.tabName) {
      this.activeTab = this.$attrs.options.tabName
    }
    this.controller.handleTabClick({name: this.activeTab});
    let vaoOverViewPageMetrics = this.companyConfig ? (((this.companyConfig.appPages || {}).vaoOverViewPage || {}).metrics || {}) : {};
    this.filterOutHiddenMetrics(vaoOverViewPageMetrics)
  },
  mounted() {
    
  }
};
</script>

<style lang="scss">
.wy-analytics-configuration {
  height: 100%;

  .dialogue-content-container {
    line-height: 25px;
    margin-left: 41px;
  }

  .el-tabs, .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
    height: 100%;    
  }
  .el-tabs__nav-scroll {
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important; 
    } 
  }
  #pane-topicKPIs.el-tab-pane, #pane-overallKPIs.el-tab-pane   {
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6px !important;
      height: 6px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 50px !important; 
    } 
  }
  .el-tabs__header {
    padding: 0px;
  }
  .el-tabs__header.is-left {
    width: 230px !important;
  }

  .el-tabs__nav.is-left {
    #tab-targetSubTitle, #tab-databaseSubTitle, #tab-alertsSubTitle, #tab-transcriptsSubTitle, #tab-configurationsTitle {
      background-color: #FFF !important;
      color: var(--site-font-secondary-color) !important;
      // border-right: 2px solid #E4E7ED;
      background-color: transparent !important;
      font-weight: 600;
    }
    #tab-targetSubTitle:hover {
      color: var(--site-font-secondary-color) !important;
    }
    #tab-targetContactReasons.is-disabled:hover {
      color: #C0C4CC !important;
    }
  }


  .el-tabs.el-tabs--left > .el-tabs__content {
    height: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 20px;
    overflow-x: auto;
    .el-tab-pane {
      width: 100%;
      height: 100%;
    }
  }
  .pane-topicBlacklist {
    min-width: 1145px;
  }
.el-loading-mask {
  .el-loading-spinner {
    top: 35%;
    background: var(--site-loading-icon);
    background-repeat: no-repeat;
    background-size: 25px;
    background-position: center;  
    .circular {
      display: inline-block;
      width: 90px;
      height: 90px; 
    }
  }
  .el-loading-spinner .path {
    -webkit-animation: loading-dash 2s ease-in-out infinite;
    animation: loading-dash 2s ease-in-out infinite;
    stroke-dasharray: 90,150;
    stroke-dashoffset: 0;
    stroke-width: 2.5 !important;
    stroke: #0C2837 !important;
    stroke-linecap: round;  
    }
  }
  .el-tabs__item:hover{
    // color: #214586;
    color: var(--site-font-primary-color);
  }
  .el-tabs__item.is-active {
    background-color: #E2ECF7;
    color: var(--site-font-primary-color);
    // color: #214586;
  }

  .el-tabs__active-bar {
    background-color: transparent;
    width: 6px !important;
  }

  div#pane-topics {
    height: 100%;
    //min-width: 1252px;
    padding-right: 20px;
  }
  div#pane-topicBlacklist {
    height: 100%;
    // min-width: 1118px;
    width: 1370px;
    // padding-right: 20px;
  }
}
.configuration-failed-message {
  top: 16% !important;
  background-color: #FFF4F4;
  border-color: #EBAFBA;
  color: var(--site-font-secondary-color);
  .el-icon-error {
    height: 15px;
    width: 15px;
    background-repeat: no-repeat;
    background-size: 15px;
    background-image: url('../../../assets/icons/icon_configuration_update_failed.svg') !important;
  }
  .el-icon-error:before {
    content: unset;
  }
  .el-message__content {
    color: var(--site-font-secondary-color);
    font-weight: 700;
  }
}
.configuration-success-message {
  background-color: #D9EEDF;
  border-color: #86D2AE;
  .el-icon-success {
    color: #186731;
  }
  .el-message__content {
    color: var(--site-font-secondary-color);
    font-weight: 700;
  }
  .el-message__closeBtn {
    color: #5C5F62;
  }
}
</style>